import 'alpinejs'
require('@coreui/coreui');
require('../bootstrap');
require('../utils');
require('./documentation/sidebar');
require('./documentation/code-generator');
